import React, { useEffect } from "react";
import uuid from "react-uuid";
import { FormatYear } from "../constants";
const ComparisonTable = ({
    tableData,
    id,
    isAllLocations,
    stratificationID,
    isAllYears,
    setTableOverFlow,
}) => {
    useEffect(() => { }, [stratificationID]);

    const filteredDataSets = tableData.DataItems.filter(
        (data) =>
            stratificationID === "VIEWALL" ||
            (stratificationID !== "VIEWALL" &&
                data.StratificationID === stratificationID)
    );

    // ******************** Below code is to show ALL strats, even those without data ********************
    const stratificationGroupedList = tableData.StratificationItems.filter(
        (strat) => strat
    );
    // ******************** Above code is to show ALL strats, even those without data ********************

    // const stratificationGroupedList = tableData.StratificationItems.filter(
    //   (strat) => strat.HasData === true
    // );

    let filteredStratificationGroupedList = stratificationGroupedList;

    if (stratificationID !== "OVR" && stratificationID === "VIEWALL") {
        filteredStratificationGroupedList.shift();
    } else if (stratificationID !== "OVR" && stratificationID !== "VIEWALL") {
        filteredStratificationGroupedList =
            filteredStratificationGroupedList.filter((strat) => {
                return strat.StratificationID === stratificationID;
            });
    }

    //filteredStratificationGroupedList = filteredStratificationGroupedList.map(
    //    (strat) => strat.Stratification
    //);

    const stratificationListLength = filteredStratificationGroupedList.length;

    const tableOverFlowClass =
        stratificationListLength >= 5 ? "table-overflow" : "";

    setTableOverFlow(tableOverFlowClass);

    const columnLength = Math.floor(12 / (stratificationListLength + 1));

    function createStateList(newDatasets) {
        return newDatasets
            .filter((value, index, self) => { return self.findIndex((v) => v.LocationAbbr === value.LocationAbbr) === index; })
            .map((data) => { return { text: data.LocationDesc, id: data.LocationAbbr } });
    }

    function createYearList(newDatasets) {
        return newDatasets
            .filter((value, index, self) => { return self.findIndex((v) => v.YearEnd === value.YearEnd) === index; })
            .map((item) => { return { text: FormatYear(item.YearStart, item.YearEnd), id: FormatYear(item.YearEnd, item.YearEnd) } });
    }

    const groupingList = isAllYears
        ? createYearList(filteredDataSets)
        : createStateList(filteredDataSets);

    function NotAllYears({ stratificationGroupedList, datasets, groupingList }) {
        let workingData = datasets;

        const dataValueUnit = workingData[0].DataValueUnit;



        return (
            <table id={"Table_" + id} key={uuid()} className="table">
                <thead>
                    <tr id={"tableHeadSection_" + id}>
                        <th
                            id="blankTopHeader"
                            scope="col"
                            aria-hidden="true"
                            className={`border-top-0 border-left-0 col-${columnLength}`}
                        >
                            <h4 className="sr-only">blank</h4>
                        </th>
                        {stratificationGroupedList.map((strat) => {
                            return (
                                <th id={strat.StratificationID}
                                    scope="col"
                                    className={`table-stratification-title  col-${columnLength}`}
                                >
                                    {strat.Stratification}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody id={"tableRows_" + id}>
                    {groupingList.map((item, groupingIndex) => {

                        const dvuId = "dvu_" + groupingIndex;
                        const ciId = "ci_" + groupingIndex;

                        return (
                            <>
                                {/* First Row of Table */}
                                <tr className="table-primary">
                                    <th
                                        id={item.id}
                                        scope="row"
                                        className="table-location-year"
                                        colSpan={stratificationListLength + 1}
                                    >
                                        {item.text}
                                    </th>

                                    {/* {stratificationGroupedList.map(() => (
                    <td aria-label="No value"></td>
                  ))} */}
                                </tr>
                                {/* Second Row of Table */}
                                <tr className="main-table-value">
                                    <th scope="row" id={dvuId} className="table-td">
                                        {/* {dataValueType} <br />
                    {"(" + dataValueUnit + ")"} */}
                                        {dataValueUnit}
                                    </th>
                                    {stratificationGroupedList.map((strat, tdIndex) => {

                                        
                                        const currentWorkingStrat = workingData.filter(
                                            (stateInfo) => {
                                                return (
                                                    stateInfo.StratificationID === strat.StratificationID &&
                                                    (stateInfo.LocationAbbr === item.id ||
                                                        stateInfo.YearEnd === item.id)
                                                );
                                            }
                                        );
                                        if (
                                            currentWorkingStrat !== null &&
                                            currentWorkingStrat.length === 1
                                        ) {
                                            return (
                                                <td headers={dvuId + " " + item.id + " " + currentWorkingStrat[0].StratificationID} >
                                                    {currentWorkingStrat[0].DataValueDisplay}{" "}
                                                    {currentWorkingStrat[0].DataValueFootnoteSymbol}
                                                </td>
                                            );
                                        } else {
                                            return <td>*</td>;
                                        }
                                    })}
                                </tr>
                                {/* Third Row of Table */}
                                <tr className="CI-value">
                                    <th id={ciId} scope="row" className="table-td">
                                        95% CI
                                    </th>
                                    {stratificationGroupedList.map((strat, tdIndex) => {
                                        const currentWorkingStrat = workingData.filter(
                                            (stateInfo) =>
                                                stateInfo.StratificationID === strat.StratificationID &&
                                                (stateInfo.LocationAbbr === item.id ||
                                                    stateInfo.YearEnd === item.id)
                                        );
                                        if (
                                            currentWorkingStrat !== null &&
                                            currentWorkingStrat.length === 1
                                        ) {
                                            return (
                                                <td headers={ciId+ " " + item.id + " " + currentWorkingStrat[0].StratificationID } >
                                                    {currentWorkingStrat[0].LowConfidenceLimitDisplay}{" "}
                                                    {" - "}{" "}
                                                    {currentWorkingStrat[0].HighConfidenceLimitDisplay}
                                                </td>
                                            );
                                        } else {
                                            return <td> - </td>;
                                        }
                                    })}
                                </tr>
                            </>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <>
            {stratificationID && (
                <NotAllYears
                    stratificationGroupedList={filteredStratificationGroupedList}
                    datasets={filteredDataSets}
                    isAllLocations={isAllLocations}
                    groupingList={groupingList}
                />
            )}
        </>
    );
};

export default ComparisonTable;
